<template>
    <svg :class="`icon-${nameLowerCased}`" class="icon" @click="clickHandler($event)"><use v-bind="{'xlink:href': `#icon-${nameLowerCased}`}" /></svg>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        clickHandler: {
            type: Function,
            default: function() {}
        }
    },
    computed: {
        nameLowerCased() {
            return this.name.toLowerCase();
        }
    }
};
</script>
